import React, { useState, useRef, useEffect } from "react";
import Btn from "../Btn/Btn";
import ListIcon from "../Icons/ListIcon";
import EditIcon from "../Icons/EditIcon";
import MessageIcon from "../Icons/MessageIcon";
import styles from "./WarningZoneMarkerPopup.module.css";
import { toDMSWithDirection } from "../../utils/geo";
interface WarningZoneProps {
    name: string;
    id: string;
    latitude: number;
    longitude: number;
    radius: number;
    severity: number;
    autoNotify: boolean;
    startTime: number;
    endTime: number;
    onEditClick: () => void;
    onMessageClick: () => void;
    onVesselInsideClick: () => void;
}

const WarningZonePopup: React.FC<WarningZoneProps> = ({
    name,
    id,
    latitude,
    longitude,
    radius,
    severity,
    autoNotify,
    startTime,
    endTime,
    onEditClick,
    onMessageClick,
    onVesselInsideClick,
}) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const btnRef = useRef<HTMLButtonElement>(null);

    return (
        <div className="text" style={{ position: "relative" }}>
            <h6>{name}</h6>
            <div>Vị trí: {toDMSWithDirection(latitude,true)}, {toDMSWithDirection(longitude,false)}</div>
            <div>Bán kính: {radius ?? "N/A"} km</div>
            <div>Tự động thông báo: {autoNotify ? "Có" : "Không"}</div>
            <div>Cảnh báo từ {new Date(startTime).toLocaleString()} đến {new Date(endTime).toLocaleString()}</div>
            <div className={styles["popup-btn-container"]}>
                <Btn
                    className="text"
                    onClick={() => setMenuOpen((v) => !v)}
                    ref={btnRef}
                >
                    ⋮
                </Btn>
                <div
                    ref={menuRef}
                    className={`${styles["popup-outer-menu"]} leaflet-popup-content-wrapper text ${
                        menuOpen ? "" : `${styles["popup-outer-menu-hidden"]}`
                    }`}
                >
                    <Btn
                        className={`text ${styles["popup-outer-menu-item"]}`}
                        id="tracker-mode"
                        title="Tàu thuyền trong vùng"
                        onClick={onVesselInsideClick}
                    >
                        <ListIcon />
                    </Btn>
                    <Btn
                        className={`text ${styles["popup-outer-menu-item"]}`}
                        id="message-mode"
                        title="Tin nhắn của vùng"
                        onClick={onMessageClick}
                    >
                        <MessageIcon />
                    </Btn>
                    <Btn
                        className={`text ${styles["popup-outer-menu-item"]}`}
                        id="edit-zone-mode"
                        title="Chỉnh sửa vùng"
                        onClick={onEditClick}
                    >
                        <EditIcon />
                    </Btn>
                </div>
            </div>
        </div>
    );
};

export default WarningZonePopup;